<ng-content select="[formaCardHeader]"></ng-content>
<div class="forma-card__body">
  <ng-content></ng-content>
</div>
<ng-content select="[formaCardFooter]"></ng-content>
<ng-content select="[formaCardActions]"></ng-content>
